// extracted by mini-css-extract-plugin
module.exports = {"detail-btn":"DetailBtn_detail-btn__xdALz","detail-btn-txt":"DetailBtn_detail-btn-txt__2Z0F0","detail-btn-icon":"DetailBtn_detail-btn-icon__myRR7"};